// Deprecated
var MultiFileUploadComponent = new JS.Class(EditorComponent, {
  initialize: function(titleSelector, fileSelector, isEmbeddedPage) {
    this.titleSelector = titleSelector;
    this.isEmbeddedPage = isEmbeddedPage;
  },

  getSaveData: function() {
    var removedFiles = getRemovedFiles();

    return {
      MultiFileUpload: {
        title: $(this.titleSelector).val(),
        removedFiles: JSON.stringify(removedFiles),
      },
    };
  },

  handleSubmitComplete: function() {
    this.filesUploaded = true;
    this.editor.savePage();
  },
});
